import axiosInstance, { getErrorMessage } from '../utils/axios';

class AdminContactService {
  baseEndpoint = '/admin/contacts';

  async getAllContacts(filters = {}, pagination = {}) {
    try {
      const params = { ...filters, ...pagination };
      const response = await axiosInstance.get(this.baseEndpoint, { params });
      return { success: true, data: response.data.data, pagination: response.data.pagination };
    } catch (error) {
      return { success: false, error: getErrorMessage(error), statusCode: error.response?.status };
    }
  }

  async getStats() {
    try {
      const response = await axiosInstance.get(`${this.baseEndpoint}/stats`);
      return { success: true, data: response.data.data };
    } catch (error) {
      return { success: false, error: getErrorMessage(error), statusCode: error.response?.status };
    }
  }

  async getById(id) {
    try {
      const response = await axiosInstance.get(`${this.baseEndpoint}/${id}`);
      return { success: true, data: response.data.data };
    } catch (error) {
      return { success: false, error: getErrorMessage(error), statusCode: error.response?.status };
    }
  }
}

const adminContactService = new AdminContactService();
export default adminContactService;
export { AdminContactService };


